export var generateGeoJson = function (platform, properties) {
    if (properties === void 0) { properties = {}; }
    return {
        type: 'Feature',
        id: platform.id,
        geometry: {
            type: 'Polygon',
            coordinates: [getCoordinates(platform)],
        },
        properties: properties,
    };
};
export var getCoordinates = function (platform) {
    var coordinates = platform.coordinates;
    if (!Array.isArray(coordinates)) {
        coordinates = JSON.parse(coordinates);
    }
    return coordinates;
};
export var isSurrounding = function (platformA, platformB) {
    var surrounding;
    if (platformA.surroundings) {
        surrounding = platformA.surroundings.find(function (p) { return p.surrounded_platform.id === platformB.id; });
    }
    else if (platformA.surrounded_surroundings) {
        surrounding = platformA.surrounded_surroundings.find(function (p) { return p.platform.id === platformB.id; });
    }
    return !!surrounding;
};
/**
 * Sort function that will sort an array of platforms by the mapState prop
 * The priroity is as follows, based on platform.mapState:
 *
 * 1. main
 * 2. surrounding
 * 3. normal
 *
 * @param {Platform} platformA
 * @param {Platform} platformB
 */
export var platformMapStateCompare = function (platformA, platformB) {
    if (platformA.mapState === platformB.mapState) {
        return 0;
    }
    else if (platformA.mapState === 'main' || (platformA.mapState === 'surrounding' && platformB.mapState !== 'main')) {
        return 1;
    }
    return -1;
};
/**
 * Find the similar platforms that have different mapState between two platform arrays
 * Used in the surroundings update screen to find and batch-update only platforms that were altered
 *
 * @param {Platform[]} stagedPlatforms
 * @param {Platform[]} allPlatforms
 */
export var getPlatformsToUpdate = function (stagedPlatforms, allPlatforms) {
    var platformsToUpdate = [];
    stagedPlatforms.forEach(function (stagedPlatform) {
        var platform = allPlatforms.find(function (p) { return p.id === stagedPlatform.id; });
        if ((platform === null || platform === void 0 ? void 0 : platform.mapState) !== stagedPlatform.mapState) {
            platformsToUpdate.push(stagedPlatform);
        }
    });
    return platformsToUpdate;
};
export var getPlatformName = function (platform) {
    if (platform) {
        var platformName = platform.name;
        // TODO: Remove after we update the platform model to support subtitle
        var nameParts = platformName.split('»');
        if (nameParts.length > 1) {
            var name_1 = nameParts[1];
            if (name_1) {
                return name_1.trim();
            }
        }
        return platformName;
    }
};
export var getPlatformInitials = function (platform) {
    if (platform) {
        var name_2 = getPlatformName(platform);
        if (name_2) {
            return name_2.substring(0, 2).toUpperCase();
        }
    }
};
export var getPlatformTitle = function (platform) {
    if (platform) {
        return platform.name.split('»').length > 1 ? platform === null || platform === void 0 ? void 0 : platform.name.split('»')[1].trim() : '&nbsp;';
    }
    return '';
};
export var getPlatformSubtitle = function (platform) {
    return (platform === null || platform === void 0 ? void 0 : platform.name.split('»').length) ? platform.name.split('»')[0].replace('«', '').trim() : '&nbsp;';
};
